export default "__VITE_ASSET__CKDj7l4C__"